<template>
	<!-- .content -->
	<div>
    <h1 class="page-header color-1-100">{{ email.subject }}</h1>
    <div class="admin-breadcrumbs">
      <router-link class="dashboard background-1-20 color-2-100" to="/">Go to Dashboard</router-link>
      <router-link class="all-users background-1-20 color-2-100" :to="{name: 'email-logs'}">
        Back to email logs
      </router-link>
    </div>
    <div class="content-section">
      <p><strong>Subject</strong>: {{ email.subject ? email.subject : 'n/a' }}</p>
      <p><strong>Status</strong>: {{ email.status ? email.status.label : 'n/a' }}</p>
      <p><strong>Mail to</strong>: {{ email.mail_to ? email.mail_to : 'n/a' }}</p>
      <p><strong>Type</strong>: {{ email.type ? email.type.label : 'n/a' }}</p>
      <p><strong>Date and time</strong>: {{ email.created ? convertDate(email.created) : 'n/a' }}</p>
      <div id="emailBody"></div>
    </div>
	</div>
	<!-- END:.content -->
</template>

<script>
import api from '@/api'

export default {
  props: ['id'],
  data () {
    return {
      email: {
        subject: '',
        text: '',
        mail_to: '',
        type: '',
        status: '',
        created: ''
      },
      emailBody: null,
      emailId: null,
      emailReady: false,
      mailTypes: [],
      mailStatuses: []
    }
  },
  created () {
    this.emailId = this.$route.params.id
    document.title = 'Clear Assured – View email ' + this.emailId
  },
  methods: {
    fetchContent () {
      this.$http.get(api.URLS.emailSingle + '/' + this.emailId, api.headersAuthSettings)
      .then((res) => {
        this.email = res.body
        this.email.type = this.mailTypes.find((type) => type.value === res.body.type)
        this.email.status = this.mailStatuses.find((status) => status.value === res.body.status)
        this.buildEmailFrame(this.email.text)
        document.title = 'View email ' + this.emailId + ' | Clear Assured'
        if (window._paq) {
          window._paq.push(['setCustomUrl', location.pathname])
          window._paq.push(['setDocumentTitle', document.title])
          window._paq.push(['trackPageView'])
        }
        // if (window.ga) {
        //   window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
        //   window.ga('send', 'pageview', {
        //     'page': location.pathname,
        //     'location': location.href,
        //     'title': document.title
        //   })
        // }
      })
      .catch((err) => console.error(err))
    },
    getFilters () {
      let self = this
      Promise.all([
        this.$http.post(api.URLS.mailTypes, {}, api.headersAuthSettings),
        this.$http.post(api.URLS.mailStatuses, {}, api.headersAuthSettings)
      ]).then(function (data) {
        self.mailTypes = data[0].body
        self.mailStatuses = data[1].body
      })
    },
    buildEmailFrame (html) {
      let iframe = document.createElement('iframe')
      document.getElementById('emailBody').appendChild(iframe)
      iframe.style.width = '100%'
      iframe.style.height = '700px'
      iframe.contentWindow.document.open()
      iframe.contentWindow.document.write(html)
      iframe.contentWindow.document.close()
    },
    convertDate (payload) {
      if (!payload) return
      let date = new Date(payload)
      let fullYear = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hours = date.getHours()
      let minutes = date.getMinutes()
      let ampm = hours >= 12 ? 'PM' : 'AM'
      let newHours = hours % 12 ? hours % 12 : 12
      function toDoubleDigit (num) {
        return num.toString().length < 2 ? '0' + num : num.toString()
      }
      let dateString = toDoubleDigit(day) + '.' + toDoubleDigit(month) + '.' + fullYear
      let timeString = toDoubleDigit(newHours) + ':' + toDoubleDigit(minutes) + ' ' + ampm
      return dateString + ' ' + timeString
    }
  },
  mounted () {
    this.getFilters()
    this.fetchContent()
  }
}
</script>

<style src='@/assets/scss/components/email.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// EmailSingle.vue?1c9ffd11